<template>
  <div class="ui grid" style="width: 100%">
    <div class="row">
      <h3 class="ui huge header">Manage teachers</h3>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <span v-if="lastSignInDate"
        >The last sign-in activity for this school was on
        {{ lastSignInDate | moment('DD-MM-YYYY') }}</span
      >
      <span v-if="!lastSignInDate"
        >There has been no sign-in activity for this school yet</span
      >
    </div>
    <div class="row">
      <sui-button
        content="Add Teacher"
        positive
        icon="plus"
        v-on:click="showAddTeacherModal()"
      >
      </sui-button>
    </div>
    <div v-if="removeTeacherError" class="ui negative message">
      <p>{{ removeTeacherError }}</p>
    </div>
    <div class="row">
      <teachers-table
        show-role="true"
        v-bind:teachers="teachers"
        v-bind:actions="teacherActions"
        v-on:rowAction="rowAction"
      />
    </div>
    <portal to="modal-destination" :order="1">
      <sui-modal v-model="addTeacherModalOpen">
        <sui-modal-header>Add New Teacher</sui-modal-header>
        <sui-modal-content class="scrolling">
          <add-teacher-form
            v-bind:teacher="newTeacher"
            v-bind:error="newTeacherError"
            v-on:saved="teacherSaved"
            ref="newTeacherForm"
          />
        </sui-modal-content>
        <sui-modal-actions>
          <sui-button negative v-on:click="hideAddTeacherModal">
            Cancel
          </sui-button>
        </sui-modal-actions>
      </sui-modal>
    </portal>
    <portal to="modal-destination" :order="1">
      <sui-modal v-model="updateTeacherModalOpen" v-if="teacher">
        <sui-modal-header>Update Teacher</sui-modal-header>
        <sui-modal-content class="scrolling">
          <update-teacher-form
            v-bind:teacher="teacher"
            v-bind:error="updateTeacherError"
            v-on:saved="teacherUpdated"
            ref="updateTeacherForm"
          />
        </sui-modal-content>
        <sui-modal-actions>
          <sui-button negative v-on:click="hideUpdateTeacherModal">
            Cancel
          </sui-button>
        </sui-modal-actions>
      </sui-modal>
    </portal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TeachersTable from '@/components/teachers/TeachersTable';
import AddTeacherForm from '@/components/teachers/AddTeacherForm';
import UpdateTeacherForm from '@/components/teachers/UpdateTeacherForm';

export default {
  name: 'ManageTeachers',
  props: ['school'],
  components: { TeachersTable, AddTeacherForm, UpdateTeacherForm },
  computed: mapGetters({
    teachers: 'teachers',
    user: 'user',
    lastSignInDate: 'lastSignInDate',
  }),
  data() {
    return {
      teacherActions: ['Update', 'Remove'],
      addTeacherModalOpen: false,
      updateTeacherModalOpen: false,
      newTeacherError: null,
      updateTeacherError: null,
      removeTeacherError: null,
      teacher: null,
      newTeacher: {
        Email: '',
        SchoolCode: '',
        IsTeacherAdmin: '',
        RequiresTraining: '',
      },
    };
  },
  methods: {
    rowAction(action) {
      if (action.action === 'Remove') {
        this.$dialog
          .confirm('Please confirm to remove this teacher')
          .then(() => {
            this.$store.dispatch('removeTeacher', action.id).then(
              () => {
                this.removeTeacherError = null;
                this.$store.dispatch('getTeachers', this.school.rollNumber);
                this.$store.dispatch(
                  'getLastTeacherSignIn',
                  this.school.rollNumber,
                );
              },
              (error) => {
                this.removeTeacherError = error.response.data;
              },
            );
          })
          .catch(() => {});
      }
      if (action.action === 'Update') {
        // eslint-disable-next-line arrow-parens
        this.teacher = this.teachers.find((t) => t.id === action.id);
        this.teacher.SchoolCode = this.school.rollNumber;
        this.teacher.isTeacherAdmin =
          this.teacher.role === 'TeacherAdministrator';
        this.updateTeacherModalOpen = true;
        this.updateTeacherError = null;
      }
    },
    showAddTeacherModal() {
      this.newTeacher = {
        Email: '',
        SchoolCode: this.school.rollNumber,
        RequiresTraining: true,
      };
      this.newTeacherError = null;
      this.addTeacherModalOpen = true;
    },
    hideAddTeacherModal() {
      this.addTeacherModalOpen = false;
    },
    hideUpdateTeacherModal() {
      this.updateTeacherModalOpen = false;
    },
    teacherUpdated() {
      this.$store.dispatch('updateTeacher', this.teacher).then(
        () => {
          this.updateTeacherError = null;
          this.$store.dispatch('getTeachers', this.school.rollNumber);
          this.$store.dispatch('getLastTeacherSignIn', this.school.rollNumber);
          this.hideUpdateTeacherModal();
        },
        (error) => {
          this.updateTeacherError = error.response.data;
        },
      );
    },
    teacherSaved() {
      this.$store.dispatch('newTeacher', this.newTeacher).then(
        () => {
          this.newTeacherError = null;
          this.$store.dispatch('getTeachers', this.school.rollNumber);
          this.$store.dispatch('getLastTeacherSignIn', this.school.rollNumber);
          this.hideAddTeacherModal();
        },
        (error) => {
          this.newTeacherError = error.response.data;
        },
      );
    },
  },
  created() {
    this.$store.dispatch('getTeachers', this.school.rollNumber);
    this.$store.dispatch('getLastTeacherSignIn', this.school.rollNumber);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/teachers/ManageTeachers.vue